import { ChangeDetectionStrategy, Component, inject } from '@angular/core';
import { FormsModule } from '@angular/forms';
import { DialogComponent } from '@interacta-shared/ui';
import { EditableTableComponent } from '@modules/editable-table';
import { closeDetail } from '@modules/table-info/store/table-info.actions';
import {
    selectTable,
    selectVisible,
} from '@modules/table-info/store/table-info.selectors';
import { Store } from '@ngrx/store';

@Component({
    selector: 'interacta-table-info-dialog',
    templateUrl: './table-info-dialog.component.html',
    changeDetection: ChangeDetectionStrategy.OnPush,
    imports: [DialogComponent, EditableTableComponent, FormsModule],
})
export class TableInfoDialogComponent {
    private store = inject(Store);

    readonly visible = this.store.selectSignal(selectVisible);
    readonly table = this.store.selectSignal(selectTable);

    close(): void {
        this.store.dispatch(closeDetail());
    }
}
